var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWomanEmptyIllustration = function SvgWomanEmptyIllustration(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 370,
    height: 200,
    viewBox: "0 0 370 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31.2656,
    y: 166.5,
    width: 17.4206,
    height: 36.1023,
    rx: 4,
    transform: "rotate(60 31.2656 166.5)",
    fill: "#61D5EE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 293.477,
    y: 173.875,
    width: 17.4206,
    height: 17.8707,
    rx: 4,
    transform: "rotate(60 293.477 173.875)",
    fill: "#FEB45E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23.4766,
    y: 33.875,
    width: 17.4206,
    height: 17.8707,
    rx: 4,
    transform: "rotate(60 23.4766 33.875)",
    fill: "#F86498"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 268.91,
    y: 6.60938,
    width: 10.8126,
    height: 11.0919,
    rx: 4,
    transform: "rotate(60 268.91 6.60938)",
    fill: "#61D5EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M333.582 46.5C339.321 43.1863 346.66 45.1528 349.974 50.8923L363.951 75.1014C367.265 80.8409 365.298 88.18 359.559 91.4937L312.022 118.939C306.282 122.253 298.943 120.286 295.63 114.547L281.653 90.3378C278.339 84.5983 280.305 77.2592 286.045 73.9455L333.582 46.5Z",
    fill: "url(#paint0_linear_1227_33853)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.746 183.312C163.74 183.83 108.612 189.313 87.9501 171.373C67.0908 153.263 63.1954 131.24 67.6399 105.739C71.9301 81.1239 106.183 73.1175 128.794 58.167C146.253 46.6224 161.004 30.6861 182.8 29.5916C205.58 28.4476 227.284 38.1299 243.335 52.4151C259.303 66.626 266.613 85.8038 268.361 105.739C270.289 127.719 268.538 150.388 253.473 167.993C236.236 188.136 221.377 182.801 192.746 183.312Z",
    fill: "#DAD8FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1227_33853",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 29,
    width: 203,
    height: 156
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.746 183.312C163.74 183.83 108.612 189.313 87.9501 171.373C67.0908 153.263 63.1954 131.24 67.6399 105.739C71.9301 81.1239 106.183 73.1175 128.794 58.167C146.253 46.6224 161.004 30.6861 182.8 29.5916C205.58 28.4476 227.284 38.1299 243.335 52.4151C259.303 66.626 266.613 85.8038 268.361 105.739C270.289 127.719 268.538 150.388 253.473 167.993C236.236 188.136 221.377 182.801 192.746 183.312Z",
    fill: "#DAD8FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1227_33853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.619 127.681L183.181 121.742L146.145 123.56V129.292C146.145 129.292 137.814 137.214 134.527 189.942H201.193C201.193 189.942 208.506 143.283 183.619 127.681Z",
    fill: "#407FFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.15 129.296L183.619 127.68",
    stroke: "black",
    strokeWidth: 1.55,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.806 153.602L161.48 156.728L165.589 189.945",
    stroke: "black",
    strokeWidth: 1.55,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.662 116.188L115.893 82.4141L138.4 90.8517L127.599 123.199C125.385 129.878 117.753 133.034 111.47 129.854C106.461 127.326 104.01 121.553 105.662 116.188Z",
    fill: "#F26E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.442 64.3805C123.467 57.7962 130.537 54.1902 137.056 56.4166C143.391 58.5837 146.808 65.4463 144.7 71.8056L138.394 90.848L115.888 82.4104L121.442 64.3746V64.3805Z",
    fill: "#FEFEF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.035 113.657L97.331 64.9198C97.331 64.9198 97.9172 56.1151 83.292 55.5881V55.5999C83.0966 55.5881 82.9012 55.5703 82.6999 55.5703H77.809C76.9031 55.5703 76.0741 56.2098 75.9498 57.1098C75.8077 58.1519 76.536 59.046 77.513 59.1704L82.4453 59.8691L75.7366 61.6572L74.4813 62.1191L65.345 56.0795C64.6167 55.5585 63.5983 55.8012 63.1779 56.5887C62.8463 57.2105 62.9943 57.9743 63.5332 58.4243C64.0957 58.8921 65.0016 59.6737 65.9963 60.5263L63.9772 59.3184C63.2075 58.8565 62.2127 59.1763 61.8575 59.9993C61.5792 60.6447 61.7864 61.3908 62.3608 61.7993C62.8522 62.1487 63.4858 62.5928 64.1608 63.0665L63.4621 62.7941C62.6923 62.4921 61.7864 62.7112 61.3127 63.3921C60.6732 64.3158 61.0581 65.5711 62.0706 65.9915L72.0537 70.1718C73.7767 70.8942 75.4228 71.3442 77.4537 70.8646L86.3532 68.7685L106.266 124.51L123.035 113.663V113.657Z",
    fill: "#F26E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.489 93.6562L117.243 102.674",
    stroke: "#DB5749",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.449 55.8815L131.892 56.598C131.892 56.598 118.061 75.3621 146.144 123.56L183.181 121.742L185.97 69.8139L181.399 55.0703H164.808L141.455 55.8815H141.449Z",
    fill: "#FEFEF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.607 87.9385C130.607 87.9385 127.854 82.1417 129.624 69.3047",
    stroke: "#FCE7E4",
    strokeWidth: 1.55,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.578 109.417L201.201 77.6562L180.287 89.5044L196.002 119.767C199.229 126.02 207.264 127.944 212.972 123.823C217.519 120.543 219.047 114.456 216.578 109.417Z",
    fill: "#F26E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.894 60.7016C189.862 54.514 182.319 52.0567 176.226 55.2778C170.305 58.4042 168.007 65.7227 171.08 71.6734L180.282 89.502L201.195 77.6538L192.894 60.7075V60.7016Z",
    fill: "#FEFEF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.288 89.5012L172.685 74.7812",
    stroke: "#FCE7E4",
    strokeWidth: 1.55,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.682 55.0795C248.214 54.3986 247.302 54.1854 246.532 54.4815L242.068 56.2223L246.266 52.6696C246.959 52.0834 247.154 51.0413 246.633 50.3012C246.029 49.4485 244.874 49.3182 244.11 49.94L240.208 53.0841L243.536 48.7321C244.087 48.0097 244.057 46.9498 243.382 46.3399C242.612 45.6353 241.458 45.7596 240.836 46.5235L234.264 53.3446L227.555 51.5564L232.487 50.8577C233.464 50.7334 234.198 49.8393 234.05 48.7972C233.926 47.8972 233.097 47.2577 232.191 47.2577H227.3C224.411 47.2577 221.592 48.2643 219.455 50.1827C219.419 50.2123 219.384 50.2301 219.348 50.2597C216.346 52.6282 217.442 57.4776 217.442 57.4776L199.021 109.631L217.276 117.731L227.798 61.723L234.518 61.7349C234.933 61.7763 235.353 61.7704 235.773 61.7349H235.827C236.549 61.6697 237.266 61.498 237.947 61.2138L247.93 57.6789C248.942 57.2526 249.327 56.0032 248.687 55.0795H248.682Z",
    fill: "#F26E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.174 87.9453L202.195 101.83",
    stroke: "#DB5749",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.709 12.8743C139.56 13.6619 131.839 15.6691 131.685 17.0724C131.685 17.0724 134.225 27.0022 131.626 28.8555C124.591 33.8648 122.341 43.6879 122.341 43.6879C122.341 43.6879 140.898 57.5848 190.221 42.9952C190.221 42.9952 190.813 37.0859 181.843 32.799C179.285 31.5733 177.005 29.7318 175.566 27.2213C174.453 25.2791 174.282 24.4561 173.985 22.7153C173.156 17.8481 159.721 -0.163999 140.715 12.8803L140.709 12.8743Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.437 27.7532C141.662 31.0098 139.205 33.8401 135.948 34.0651C132.692 34.2901 129.861 31.8329 129.636 28.5762C129.411 25.3196 131.869 22.4893 135.125 22.2643C138.382 22.0393 141.212 24.4966 141.437 27.7532Z",
    fill: "#DB5749"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.107 42.2384L144.925 55.105C145.203 59.6229 147.05 62.7019 151.497 62.394C155.292 62.1275 159.804 59.09 160.012 55.2945L157.75 35.1094L144.107 42.2443V42.2384Z",
    fill: "#F26E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.449 55.8893L164.802 55.0781C164.802 55.0781 164.233 66.5592 150.354 65.4875C140.703 64.7414 141.449 55.8952 141.449 55.8952V55.8893Z",
    fill: "#F26E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.783 52.8378L159.71 38.2422L144.001 40.9245L144.783 52.8378Z",
    fill: "#DB5749"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.027 44.3225C140.425 44.3462 134.148 38.3599 133.923 32.1545L133.473 17.5116C133.189 9.7312 139.128 3.12913 146.89 2.59031C154.837 2.03964 163.126 7.93709 163.677 15.8833L163.908 27.6663C164.085 36.7789 157.116 43.6889 148.021 44.3225H148.027Z",
    fill: "#F26E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.893 26.9922L141.449 30.6337L143.332 30.6988",
    stroke: "black",
    strokeWidth: 1.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.429 33.2206C146.429 33.2206 144.445 32.3146 142.041 34.387",
    stroke: "black",
    strokeWidth: 1.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.831 27.8079C172.056 31.0645 169.598 33.8948 166.342 34.1198C163.085 34.3448 160.255 31.8875 160.03 28.6309C159.805 25.3743 162.262 22.544 165.519 22.319C168.775 22.094 171.606 24.5513 171.831 27.8079Z",
    fill: "#F26E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.672 29.9147C163.672 29.9147 163.376 25.6396 167.509 26.0245",
    stroke: "black",
    strokeWidth: 1.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M105.662 116.188L115.893 82.4141L138.4 90.8517L127.599 123.199C125.385 129.878 117.753 133.034 111.47 129.854C106.461 127.326 104.01 121.553 105.662 116.188Z",
    fill: "#FFBE9D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M121.442 64.3805C123.467 57.7962 130.537 54.1902 137.056 56.4166C143.391 58.5837 146.808 65.4463 144.7 71.8056L138.394 90.848L115.888 82.4104L121.442 64.3746V64.3805Z",
    fill: "#FEFEF4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M123.035 113.657L97.331 64.9198C97.331 64.9198 97.9172 56.1151 83.292 55.5881V55.5999C83.0966 55.5881 82.9012 55.5703 82.6999 55.5703H77.809C76.9031 55.5703 76.0741 56.2098 75.9498 57.1098C75.8077 58.1519 76.536 59.046 77.513 59.1704L82.4453 59.8691L75.7366 61.6572L74.4813 62.1191L65.345 56.0795C64.6167 55.5585 63.5983 55.8012 63.1779 56.5887C62.8463 57.2105 62.9943 57.9743 63.5332 58.4243C64.0957 58.8921 65.0016 59.6737 65.9963 60.5263L63.9772 59.3184C63.2075 58.8565 62.2127 59.1763 61.8575 59.9993C61.5792 60.6447 61.7864 61.3908 62.3608 61.7993C62.8522 62.1487 63.4858 62.5928 64.1608 63.0665L63.4621 62.7941C62.6923 62.4921 61.7864 62.7112 61.3127 63.3921C60.6732 64.3158 61.0581 65.5711 62.0706 65.9915L72.0537 70.1718C73.7767 70.8942 75.4228 71.3442 77.4537 70.8646L86.3532 68.7685L106.266 124.51L123.035 113.663V113.657Z",
    fill: "#FFBE9D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M112.489 93.6562L117.243 102.674",
    stroke: "#FF9A66",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M141.449 55.8815L131.892 56.598C131.892 56.598 118.061 75.3621 146.144 123.56L183.181 121.742L185.97 69.8139L181.399 55.0703H164.808L141.455 55.8815H141.449Z",
    fill: "#FEFEF4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M130.607 87.9385C130.607 87.9385 127.854 82.1417 129.624 69.3047",
    stroke: "#FCE7E4",
    strokeWidth: 1.55,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M216.578 109.417L201.201 77.6562L180.287 89.5044L196.002 119.767C199.229 126.02 207.264 127.944 212.972 123.823C217.519 120.543 219.047 114.456 216.578 109.417Z",
    fill: "#FFBE9D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M192.894 60.7016C189.862 54.514 182.319 52.0567 176.226 55.2778C170.305 58.4042 168.007 65.7227 171.08 71.6734L180.282 89.502L201.195 77.6538L192.894 60.7075V60.7016Z",
    fill: "#FEFEF4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M180.288 89.5012L172.685 74.7812",
    stroke: "#FCE7E4",
    strokeWidth: 1.55,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M248.682 55.0795C248.214 54.3986 247.302 54.1854 246.532 54.4815L242.068 56.2223L246.266 52.6696C246.959 52.0834 247.154 51.0413 246.633 50.3012C246.029 49.4485 244.874 49.3182 244.11 49.94L240.208 53.0841L243.536 48.7321C244.087 48.0097 244.057 46.9498 243.382 46.3399C242.612 45.6353 241.458 45.7596 240.836 46.5235L234.264 53.3446L227.555 51.5564L232.487 50.8577C233.464 50.7334 234.198 49.8393 234.05 48.7972C233.926 47.8972 233.097 47.2577 232.191 47.2577H227.3C224.411 47.2577 221.592 48.2643 219.455 50.1827C219.419 50.2123 219.384 50.2301 219.348 50.2597C216.346 52.6282 217.442 57.4776 217.442 57.4776L199.021 109.631L217.276 117.731L227.798 61.723L234.518 61.7349C234.933 61.7763 235.353 61.7704 235.773 61.7349H235.827C236.549 61.6697 237.266 61.498 237.947 61.2138L247.93 57.6789C248.942 57.2526 249.327 56.0032 248.687 55.0795H248.682Z",
    fill: "#FFBE9D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M206.174 87.9453L202.195 101.83",
    stroke: "#FF9A66",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M140.709 12.8743C139.56 13.6619 131.839 15.6691 131.685 17.0724C131.685 17.0724 134.225 27.0022 131.626 28.8555C124.591 33.8648 122.341 43.6879 122.341 43.6879C122.341 43.6879 140.898 57.5848 190.221 42.9952C190.221 42.9952 190.813 37.0859 181.843 32.799C179.285 31.5733 177.005 29.7318 175.566 27.2213C174.453 25.2791 174.282 24.4561 173.985 22.7153C173.156 17.8481 159.721 -0.163999 140.715 12.8803L140.709 12.8743Z",
    fill: "#0B072A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M141.437 27.7532C141.662 31.0098 139.205 33.8401 135.948 34.0651C132.692 34.2901 129.861 31.8329 129.636 28.5762C129.411 25.3196 131.869 22.4893 135.125 22.2643C138.382 22.0393 141.212 24.4966 141.437 27.7532Z",
    fill: "#FF9A66"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M144.107 42.2384L144.925 55.105C145.203 59.6229 147.05 62.7019 151.497 62.394C155.292 62.1275 159.804 59.09 160.012 55.2945L157.75 35.1094L144.107 42.2443V42.2384Z",
    fill: "#FFBE9D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M141.449 55.8893L164.802 55.0781C164.802 55.0781 164.233 66.5592 150.354 65.4875C140.703 64.7414 141.449 55.8952 141.449 55.8952V55.8893Z",
    fill: "#FFBE9D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M144.783 52.8378L159.71 38.2422L144.001 40.9245L144.783 52.8378Z",
    fill: "#FF9A66"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M148.027 44.3225C140.425 44.3462 134.148 38.3599 133.923 32.1545L133.473 17.5116C133.189 9.7312 139.128 3.12913 146.89 2.59031C154.837 2.03964 163.126 7.93709 163.677 15.8833L163.908 27.6663C164.085 36.7789 157.116 43.6889 148.021 44.3225H148.027Z",
    fill: "#FFBE9D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M147.427 35.2723C147.269 35.4713 145.987 34.3582 144.077 34.704C142.167 35.0498 141.111 36.5354 140.926 36.3883C140.843 36.3223 140.949 35.8617 141.446 35.2622C142.108 34.4927 143.013 33.9736 144.01 33.7921C144.945 33.6241 145.908 33.8196 146.7 34.3387C147.323 34.7606 147.516 35.1862 147.427 35.2723Z",
    fill: "#0B072A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M153.277 22.1997C153.039 22.437 152.026 21.7983 150.693 21.3491C149.361 20.9 148.176 20.7626 148.131 20.4224C148.117 20.2673 148.417 20.0788 148.953 20.0186C149.667 19.9306 150.391 20.0114 151.068 20.2545C151.751 20.4816 152.369 20.8682 152.871 21.3818C153.265 21.7425 153.391 22.0862 153.277 22.1997Z",
    fill: "#0B072A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M139.241 21.7333C139.112 22.0439 138.247 21.994 137.294 22.2414C136.341 22.4888 135.58 22.8908 135.322 22.6745C135.203 22.5663 135.26 22.2726 135.549 21.9607C135.947 21.5443 136.457 21.2512 137.018 21.1166C137.58 20.9821 138.168 21.0119 138.713 21.2025C139.119 21.3638 139.3 21.599 139.241 21.7333Z",
    fill: "#0B072A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M141.892 26.9922L141.448 30.6337L143.331 30.6988",
    stroke: "#0B072A",
    strokeWidth: 1.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M139.074 25.6099C139.098 26.3501 138.517 26.9718 137.777 26.9955C137.037 27.0192 136.415 26.4389 136.392 25.6987C136.368 24.9586 136.948 24.3369 137.689 24.3132C138.429 24.2895 139.05 24.8698 139.074 25.6099Z",
    fill: "#0B072A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M150.354 25.2427C150.378 25.9829 149.798 26.6046 149.058 26.6283C148.317 26.652 147.696 26.0717 147.672 25.3316C147.648 24.5914 148.229 23.9697 148.969 23.946C149.709 23.9223 150.331 24.5026 150.354 25.2427Z",
    fill: "#0B072A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M151.591 0.0716602C149.697 -0.0289991 147.784 0.178242 145.954 0.669696C141.401 1.88353 133.23 5.25266 131.827 13.9982C131.359 16.3015 131.685 17.0772 131.685 17.0772C131.685 17.0772 146.949 17.6752 155.979 13.412C157.276 18.9127 158.478 22.3174 163.913 27.6701L168.739 20.4226L174.169 25.2898C174.204 25.4733 174.198 1.27365 151.603 0.0716602H151.591Z",
    fill: "#0B072A"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M171.831 27.8079C172.056 31.0645 169.598 33.8948 166.342 34.1198C163.085 34.3448 160.255 31.8875 160.03 28.6309C159.805 25.3743 162.262 22.544 165.519 22.319C168.775 22.094 171.606 24.5513 171.831 27.8079Z",
    fill: "#FFBE9D"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M167.69 25.7883C167.69 26.0425 165.994 25.9687 164.714 27.4278C163.433 28.887 163.531 30.7069 163.295 30.7069C163.189 30.7069 162.985 30.2806 163.001 29.5018C163.041 28.4874 163.426 27.5177 164.094 26.7556C164.722 26.0421 165.597 25.5965 166.54 25.5096C167.29 25.4522 167.706 25.6654 167.69 25.7883Z",
    fill: "#0B072A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1227_33853",
    x1: 356.963,
    y1: 62.9969,
    x2: 288.641,
    y2: 102.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.25
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWomanEmptyIllustration);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "woman_empty_illustration.2bdb778.svg";